import { useQuery } from 'react-query';
import { get } from '../../../lib/api';

export const useFetchConversations = ({ assistantUuid }) => {
  const { isFetched, data: conversations, refetch } = useQuery(
    ['conversations', assistantUuid],
    () => get(`/api/ai/conversations?assistant_uuid=${assistantUuid}`),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      initialData: [],
    },
  );

  return { isFetched, conversations, refetchConversations: refetch };
};
